import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LocalStorageEnum, StorageService } from '../services';
import { inject } from '@angular/core';
import { AuthUtils } from '../utils/auth-util';
import { CLIENT_TYPE, RECAPTCHA_ENABLED } from '../utils';
import {
  RECAPTCHA_ENDPOINTS,
  RECAPTCHA_HEADER_KEY,
} from '../constants/recaptcha.config';

export const httpAuthInterceptor: HttpInterceptorFn = (
  req,
  next,
): Observable<HttpEvent<unknown>> => {
  const storageService = inject(StorageService);

  const accessToken = storageService.get(LocalStorageEnum.AccessToken);

  let headers = req.headers.set('X-Client-Type', inject(CLIENT_TYPE));

  if (accessToken && !AuthUtils.isTokenExpired(accessToken)) {
    headers = headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const isRecaptchaUrl =
    inject(RECAPTCHA_ENABLED) &&
    RECAPTCHA_ENDPOINTS.some((ep) => req.url.includes(ep));
  if (isRecaptchaUrl && !headers.has(RECAPTCHA_HEADER_KEY)) {
    const token =
      (typeof window !== 'undefined'
        ? (window as any).grecaptcha?.getResponse?.()
        : '') || '';
    headers = headers.set(RECAPTCHA_HEADER_KEY, token);
  }

  const reqObservable = next(req.clone({ headers }));

  if (isRecaptchaUrl) {
    return reqObservable.pipe(
      finalize(() => {
        if (typeof window !== 'undefined' && (window as any).grecaptcha?.reset) {
          try {
            (window as any).grecaptcha.reset();
          } catch {
            // ignore
          }
        }
      }),
    );
  }

  return reqObservable;
};
